import CompanyDashboardSidebarModule from './containers/companyDashboardSidebarModule'

export {default as CompanyDashboardSidebarModuleLayout} from './components/companyDashboardSidebarModuleLayout'

export default CompanyDashboardSidebarModule
